import React from 'react';
import { SectionProps } from '../types';
import { DietaryAttributeEnum, SidebarSectionEnum } from '../enums';
import DietaryIcon from '../../../../assets/icons/DietaryIcon';

const LABELS_BY_ATTRIBUTE: Record<DietaryAttributeEnum, string> = {
  [DietaryAttributeEnum.Vegetarian]: 'Vegetarian',
  [DietaryAttributeEnum.Vegan]: 'Vegan',
  [DietaryAttributeEnum.Halal]: 'Halal',
  [DietaryAttributeEnum.GlutenFree]: 'Gluten Free',
  [DietaryAttributeEnum.DairyFree]: 'Dairy Free',
  [DietaryAttributeEnum.Spicy]: 'Spicy',
};

const DietaryInfo = ({ data, ...rest }: SectionProps) => {
  return (
    <section {...rest} id={SidebarSectionEnum.DietaryInfo}>
      <h4 className="text-md font-semibold text-slate-700 flex">
        <DietaryIcon className="size-4 mr-2" />
        Dietary Information
      </h4>
      <div className="flex gap-3 flex-wrap">
        {data?.dietary.map((attr) => (
          <p key={attr} className="rounded-full px-3 py-1 bg-gray-200/10 hover:bg-gray-200/20">
            {LABELS_BY_ATTRIBUTE[attr]}
          </p>
        ))}
      </div>
      <p className="text-xs text-slate-600 bg-gray-200/30 p-3 rounded-lg">
        <strong>Allergens: </strong>All dishes may contain traces of gluten, nuts, and dairy
        products.
      </p>
    </section>
  );
};

export default DietaryInfo;
